import { keysToCamel } from "@lib/snakeTocamel"

export const parseResponseData = (data) => {
    const widgetData = data?.widgets
    const fieldOrder = data?.fields_order
    const bottomSheets = {}
    if (!fieldOrder || fieldOrder.length === 0) return []
    let parsedData = {}
    const leftSectionWidgets = { type: "summary_left_section" }
    const rightSectionWidgets = { type: "summary_right_section" }
    Object.keys(fieldOrder)?.forEach((fieldName) => {
        const widgetType = fieldOrder[fieldName]
        switch (widgetType) {
            case "summary_banner_info": {
                const { banner_info } = widgetData[widgetType]
                const { text, image, secondary_cta, sub_text } = banner_info || {}
                let primaryCta = banner_info?.primary_cta
                if (widgetData?.bottom_cta) {
                    const ctaData = widgetData?.bottom_cta?.bottom_cta_info
                    primaryCta = {
                        text: ctaData?.label,
                        action: ctaData?.action,
                        ga_details: ctaData?.ga_details,
                        url: ctaData?.redirect_url,
                    }
                }

                parsedData.banner = {
                    type: widgetType,
                    data: {
                        text: text,
                        image: {
                            ...image,
                            url: image?.url,
                            alt: image?.alt,
                        },
                        internalData: {
                            internalSubHeader: sub_text,
                            primaryCTA: primaryCta
                                ? {
                                      label: primaryCta?.text,
                                      url: primaryCta?.url,
                                      gaDetails: primaryCta?.ga_details,
                                      action: primaryCta?.action,
                                  }
                                : null,
                            secondaryCTA: secondary_cta
                                ? {
                                      label: secondary_cta?.text,
                                      url: secondary_cta?.url,
                                      gaDetails: secondary_cta?.ga_details,
                                  }
                                : null,
                        },
                    },
                }
                break
            }
            case "summary_track_info": {
                const { cta, text } = widgetData[widgetType].track_info || {}
                return {
                    type: widgetType,
                    data: {
                        text: text,
                        cta: { ...keysToCamel(cta), gaDetails: cta?.ga_details },
                    },
                }
            }

            case "summary_personal_details": {
                const { row, text } = widgetData[widgetType].personal_details_info || {}
                leftSectionWidgets[widgetType] = {
                    header: text,
                    row: keysToCamel(row),
                }
                break
            }
            case "summary_test_details": {
                const { header, sub_header } = widgetData[widgetType].test_details_info || {}
                leftSectionWidgets[widgetType] = {
                    header,
                    row: [
                        {
                            key: "package",
                            text: sub_header,
                            image: {
                                alt: "",
                                url: "https://onemg.gumlet.io/staging/4d11b73b-3f67-4ea2-8445-a0415f4bb28f.svg",
                                width: "48px",
                                height: "48px",
                            },
                            label: "Package",
                        },
                    ],
                }
                break
            }
            case "path_booking_details": {
                const { row } = widgetData[widgetType].path_booking_info || {}
                leftSectionWidgets[widgetType] = {
                    header: widgetData[widgetType].header,
                    row: keysToCamel(row),
                }
                break
            }
            case "radio_booking_details": {
                const { row } = widgetData[widgetType].radio_booking_info || {}
                leftSectionWidgets[widgetType] = {
                    header: widgetData[widgetType].header,
                    row: keysToCamel(row),
                }
                break
            }

            case "summary_next_steps": {
                const { row, text } = widgetData[widgetType].next_steps_info || {}
                rightSectionWidgets[widgetType] = {
                    text: text,
                    row: keysToCamel(row),
                }
                return
            }
            case "summary_instruction": {
                const { header, path_details, radio_details } = widgetData[widgetType].instruction_info || {}
                const rows = []
                path_details &&
                    rows.push({
                        header: path_details.header,
                        data: path_details.data,
                        backgroundColor: path_details.background_color,
                    })
                radio_details &&
                    rows.push({
                        header: radio_details.header,
                        data: radio_details.data,
                        backgroundColor: radio_details.background_color,
                    })
                rightSectionWidgets[widgetType] = {
                    header: header,
                    rows,
                }
                break
            }
            case "summary_note": {
                rightSectionWidgets[widgetType] = {
                    value: widgetData[widgetType].note_info?.text || "",
                    backgroundColor: widgetData[widgetType]?.note_info.background_color || "",
                    header: widgetData[widgetType]?.note_info.header,
                    rows: widgetData[widgetType]?.note_info.rows,
                }

                break
            }

            case "primary_decision_hyperlink":
                rightSectionWidgets[widgetType] = {
                    header: widgetData[widgetType]?.data?.heading,
                    image: {
                        src: widgetData[widgetType]?.data?.items?.[0]?.icon || "",
                        height: "48px",
                        width: "48px",
                    },
                    linksData: widgetData[widgetType]?.data?.items?.map((item) => ({
                        header: item?.name,
                        subTitle: item?.sub_text,
                        url:
                            item?.type === "call"
                                ? `tel:${item.cta?.details?.support_contact}`
                                : item?.cta?.details?.target_url,
                        isExternal: true,
                    })),
                }
                break
        }
    })
    parsedData = { ...parsedData, leftSectionWidgets, rightSectionWidgets }
    if (data?.bottom_sheets) {
        Object.entries(data.bottom_sheets).map(([key, value]) => {
            bottomSheets[key] = keysToCamel(value)
        })
    }

    return { widgets: parsedData, gaDetails: data?.ga_details, bottomSheets }
}
